import { render, staticRenderFns } from "./CompoundInput.vue?vue&type=template&id=68241d08&scoped=true&"
import script from "./CompoundInput.vue?vue&type=script&lang=js&"
export * from "./CompoundInput.vue?vue&type=script&lang=js&"
import style0 from "./CompoundInput.vue?vue&type=style&index=0&id=68241d08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68241d08",
  null
  
)

export default component.exports